import React, { Component } from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import styled from "styled-components";

import { State } from "src/state/ducks";
import * as shopActions from "src/state/ducks/shop/actions";
import * as tagActions from "src/state/ducks/master/actions";
import { ShopEntity } from "src/firebase/db/Shops";

import StyleConfig from "src/constants/StyleConfig";
import { DefaultPageProps, HistoryProps } from "src/constants/Interface";

import { DefaultLayout } from "src/components/layouts/DefaultLayout";
import Heading from "src/components/atoms/typo/Heading";
import ShopForm from "src/components/organisms/form/ShopForm";
import SpinnerModal from "src/components/organisms/loading/SpinnerModal";

type Props = DefaultPageProps &
  HistoryProps &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

class ShopCreatePage extends Component<Props> {
  componentDidMount() {
    this.props.getTags();
    this.props.setDraft();
  }

  render() {
    const { isFetching, tags, errors, draft, createShop } = this.props;
    return (
      <DefaultLayout {...this.props}>
        <SpinnerModal isLoading={isFetching} />
        <Block>
          <Heading tag="h1" color="primary" text="基本情報を編集する" />
          <ShopForm
            formType="CREATE"
            onSubmit={createShop}
            shop={draft}
            tags={tags}
            hasNotifications={false}
            errors={errors}
          />
        </Block>
      </DefaultLayout>
    );
  }
}

const Block = styled.div`
  box-sizing: border-box;
  padding: ${StyleConfig.HELPER.M20};
`;

const mapStateToProps = (state: State) => ({
  isFetching: state.master.isFetching || state.shop.isFetching,
  tags: state.master.tags,
  draft: state.shop.draft,
  errors: state.shop.validationErrors,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getTags: () => dispatch(tagActions.getTags()),
  setDraft: () => dispatch(shopActions.setDraft()),
  createShop: (query: ShopEntity) => dispatch(shopActions.createShop(query)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ShopCreatePage);
